import React, { useState } from "react";
import Footer from "../Footer";
import Header from "./Header";
import { Link } from "react-router-dom";

function Analysis() {
  document.title='HR School - Articles Analysis'
  const [color, setColor] = useState("black");
  const [text, setText] = useState("");
  const [darkmode, setdarkmode] = useState(false);



  const handleUpclieck = () => {
    console.log("Uppercase is clicked" + text);
    let newText = text.toUpperCase();
    setText(newText);
    setColor("green");
  };
  const handleDwclieck = () => {
    console.log("Uppercase is clicked" + text);
    let newText = text.toLowerCase();
    setText(newText);
    setColor("green");
  };
  const textCopy = () => {
    let typetext = document.getElementById("myBox");
    typetext.select();
    navigator.clipboard.writeText(typetext.value);
  };
  const changeit = (event) => {
    setText(event.target.value);
    console.log("change word");
  };
  const removespace = () => {
    let Mytext = text.split(/[ ]+/);
    setText(Mytext.join(" "));
  };
  const cleartext = () => {
    let Newtext = "";
    setText(Newtext);
  };
  return (
    <div>
      <Header />
      <div>
        <section
          id="page-banner"
          class="pt-105 pb-130 bg_cover"
          data-overlay="8"
          style={{ backgroundImage: "url(images/page-banner-5.jpg)" }}
        >
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <div class="page-banner-cont">
                  <h2>Articles Analysis</h2>
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item">
                        <Link to="/">Home</Link>
                      </li>
                      <li class="breadcrumb-item active" aria-current="page">
                        Articles Analysis
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div> <br /><br /><br />
      <div className="container">
        <div className="mb-3">
          <textarea
            class="form-control"
            id="myBox"
            value={text}
            rows="10"
            onChange={changeit}
          ></textarea>
          <button className="btn btn-primary mx-2" onClick={handleUpclieck}>
            Convert to Uppercase
          </button>
          <button className="btn btn-primary mx-2" onClick={handleDwclieck}>
            Convert to Lowercase
          </button>
          <button className="btn btn-primary mx-2" onClick={textCopy}>
            Copy text
          </button>
          <button className="btn btn-primary mx-2" onClick={removespace}>
            Remove Spaces
          </button>
          <button className="btn btn-primary mx-2" onClick={cleartext}>
            Clear Text
          </button>
        </div>
        <div className="container my-3">
          <h2>Your Text Lenght</h2>
          <p>
            {text.split(/\s+/).filter((element)=>{return element.length!==0}).length} Word and {text.length} character
          </p>
          <p>Preview</p>
          <p>{text.length > 0 ? text : "Nothing to Preview"}</p>
         {/* <div className="col-md-12"> <p style={{maxWidth:"100%"}}>{text}</p></div> */}
         {/* const mystyle = {
    fontSize: 16,
    color: color,
    marginTop: 50,

  }; */}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Analysis;
